/**
 * Formik's per-field error state, in the shape MUI wants.
 *
 * An error is only shown once the field has been touched, so a form does not greet the
 * user in red. `touched` is deliberately not coerced to a boolean by the caller: Formik
 * reports an array-valued field's touched state as an *array* of booleans, and every
 * component was re-deriving that rule slightly differently.
 *
 * @param {{error?: string, touched?: boolean|Array, helperText?: string}} field
 * @returns {{hasError: boolean, message: string|undefined}}
 */
export default function getFieldStatus({ error, touched, helperText }) {
  const hasError = Boolean(error && touched);

  return {
    hasError,
    message: (hasError && error) || helperText || undefined,
  };
}
